import { Injectable } from '@angular/core';
import { UiConfig, UiConfigGQL } from '../../../generated/graphql';
import { Title } from '@angular/platform-browser';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  data: UiConfig = {
    updateLawyers: false,
    importWatches: false,
    importLawyers: false,
    importList: false,
    logo: '',
    title: 'zAbogados',
    showWatchesOrder: false,
    demoMode: false,
    showSeniorityControls: false,
    justifyAlerts: true,
    justifyShifts: true,
    showShiftQueueControls: false,
  };

  private _loaded$ = new ReplaySubject<UiConfig>(1);
  readonly loaded$: Observable<UiConfig> = this._loaded$.asObservable();

  constructor(
    private uiService: UiConfigGQL,
    private titleService: Title
  ) {
    this.uiService.fetch().subscribe({
      next: s => {
        this.data = s.data.uiConfig;
        this.titleService.setTitle(this.data.title);
        this._loaded$.next(this.data);
      },
      error: () => {
        this._loaded$.next(this.data);
      },
    });
  }
}
